module.exports = __webpack_public_path__ + "static/person-to-person2-37dedbd4a82bf26505ae6f41554daae3.jpg";